import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

if (rootElement.dataset.prerenderShell) {
  // Some routes include styled, crawlable first-paint shells in the build.
  // Clear it synchronously before mounting so React never tries to hydrate
  // intentionally simplified markup and visitors do not see a mismatch flash.
  rootElement.replaceChildren();
  delete rootElement.dataset.prerenderShell;
  ReactDOM.createRoot(rootElement).render(app);
} else if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}

reportWebVitals();
